import React, { Component, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import withRouter from '../../../components/withRouter';
import Aux from "../../../../hoc/_Aux";
import Auth from '../../../../models/Auth'
import { RELEASE_NOTES_INFO, GET_REFERENCE_FILE } from '../../../../store/actions/newRequest';
import { GET_CLIENT_TERMS } from '../../../../store/actions/termsPrivacy';
import { connect } from 'react-redux';
import { cacheService } from '../../../../helper/utils';

const mapStateToProps = state => {

    return {
        termsPrivacy: state.termsPrivacy.termsPrivacyDetail
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
        RELEASE_NOTES_INFO: (payload) => dispatch(RELEASE_NOTES_INFO(payload)),
        // USER_Hide_All_NewReleaseInfo: (payload) => dispatch(USER_Hide_All_NewReleaseInfo(payload)),
        GET_REFERENCE_FILE: (payload) => dispatch(GET_REFERENCE_FILE(payload)),
        GET_CLIENT_TERMS: (payload) => GET_CLIENT_TERMS(payload)
    }
}


class Footer extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showReleaseModal: false,
            releaseNoteInfo: '',
            hideAllNewReleaseInfo: false,
            releaseNoteData: [],
            isResetPassword: this.props.location.pathname === '/home/reset-password',
        }
    }

    componentDidMount = async () => {
        this.currentVersion = cacheService.getCache('releaseVersion') || '';
        this.setState({ currentVersion: this.currentVersion });

        // let releaseVersionShown = cacheService.getCache('releaseVersionShown') || '';
        // let showReleaseModal = false;
        // if (typeof Auth.lastVersion !== 'undefined' && releaseVersionShown === '') {
        //     //if((this.currentVersion !== '' && Auth.lastVersion !== this.currentVersion) && Auth.hideNewReleaseInfo === false) 
        //     if (Auth.hideNewReleaseInfo === false && !this.state.isResetPassword) {
        //         showReleaseModal = true;
        //     }
        // }
        // if (showReleaseModal === true) {
        //     let releaseData = await this.props.RELEASE_NOTES_INFO({ "version": this.currentVersion, "portal": "User" });//{"version":this.currentVersion},
        //     if (releaseData && releaseData.length > 0) {
        //         this.setState({ releaseNoteData: releaseData, showReleaseModal });
        //     } else {
        //         this.setState({ releaseNoteData: [], showReleaseModal });
        //     }
        // }
    }

    downloadReleaseNotesFile = async (event, index, docName) => {
        await this.props.GET_REFERENCE_FILE({ docName })
    }

    closeReleaseModal = () => {
        this.setState({ showReleaseModal: false });
        cacheService.setCache('releaseVersionShown', '1');
    }

    setReleaseModal = () => {
        this.setState({ showReleaseModal: true });
    }

    render() {

        return (
            <Fragment>

                {/* /.content-wrapper */}
                <footer className="main-footer" style={{textAlign: "right", fontSize: "0.875rem", backgroundColor: "#F8F8F8", border: "none", padding: "80px 12px 4px 12px"}}>
                    <span>2024 Copyright All Right reserved by SK tes</span>
                </footer>
            </Fragment>
        );
    }
}
// export default connect(null, mapDispatchToProps)(Footer)
// export default Footer; //connect(mapDispatchToProps)(Footer);
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Footer));